/* tslint:disable */
/* eslint-disable */
/**
 * Swagger wiegaaterkoffiehalen
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.3.5
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Drink
 */
export interface Drink {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    icon: string;
    /**
     * 
     */
    active: boolean;
    /**
     * 
     */
    extras?: string;
}

/**
 * Check if a given object implements the Drink interface.
 */
export function instanceOfDrink(value: object): value is Drink {
    if ((!('id' in (value as Record<string, any>)) && !('_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['id'] === undefined && (value as Record<string, any>)['_id'] === undefined)) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('icon' in value) || value['icon'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    return true;
}

export function DrinkFromJSON(json: any): Drink {
    return DrinkFromJSONTyped(json, false);
}

export function DrinkFromJSONTyped(json: any, ignoreDiscriminator: boolean): Drink {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['_id'],
        'name': json['name'],
        'icon': json['icon'],
        'active': json['active'],
        'extras': json['extras'] == null ? undefined : json['extras'],
    };
}

export function DrinkToJSON(json: any): Drink {
    return DrinkToJSONTyped(json, false);
}

export function DrinkToJSONTyped(value?: Drink | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '_id': value['id'],
        'name': value['name'],
        'icon': value['icon'],
        'active': value['active'],
        'extras': value['extras'],
    };
}

